import template from './periodCard.html';
import controller from './periodCard.controller';
import './periodCard.scss';

let periodCardComponent = {
  restrict: 'E',
  bindings: {
    period: '<',
    cardId: '@',
    isMobileApp: '<',
    onRemovePeriod: '&',
    onEditPeriod: '&',
    onAddPeriod: '&',
    isInception: '<',
    readOnly: '<',
    isTeamCalendarMobile: '<'
  },
  template,
  controller
};

export default periodCardComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/myVacations/periodList/periodCard/periodCard.component.js